// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1A6ZP","text":"SelectPayment_text__BnLtv","title":"SelectPayment_title__3r3sU","btn":"SelectPayment_btn__3iFpT"};